import { cva } from 'class-variance-authority'

export const fieldButtonVariants = cva(
  'flex w-full items-center justify-between gap-2 rounded-xl bg-surface-muted outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-focus',
  {
    variants: {
      size: {
        base: 'px-3.5 py-2.5 text-base',
        small: 'px-3 py-1.5 text-sm',
      },
    },
    defaultVariants: { size: 'base' },
  },
)

export const fieldIconVariants = cva('shrink-0 text-primary', {
  variants: {
    size: {
      base: 'size-4',
      small: 'size-3.5',
    },
  },
  defaultVariants: { size: 'base' },
})

export const standardButtonVariants = cva(
  'flex items-center gap-2 rounded-sm outline-none hover:text-blue-500 focus-visible:text-blue-500',
  {
    variants: {
      size: {
        base: 'text-base',
        small: 'text-sm',
      },
    },
    defaultVariants: { size: 'base' },
  },
)

export const standardLinkVariants = cva(
  'flex items-center rounded-sm outline-none hover:text-blue-500 focus-visible:text-blue-500',
)

export const standardIconVariants = cva('shrink-0', {
  variants: {
    size: {
      base: 'size-3.5',
      small: 'size-3',
    },
  },
  defaultVariants: { size: 'base' },
})
